<template>
  <div>
    <SectionContainer bg-color="light">
      <SHeadingSkeleton size="2" width="60%" />
      <STextSkeleton font-size="lg" width="25rem" />
      <div class="company-wall-details-internal-links__company-list">
        <CompanyWallMunicipalityCardSkeleton v-for="i in 4" :key="i" />
      </div>
    </SectionContainer>

    <SectionContainer size="md">
      <SHeadingSkeleton size="2" width="60%" />
      <STextSkeleton font-size="lg" width="25rem" />
      <SButtonListSkeleton />
    </SectionContainer>

    <SectionContainer size="md">
      <SHeadingSkeleton size="2" width="60%" />
      <STextSkeleton font-size="lg" width="25rem" />
      <SButtonListSkeleton />
    </SectionContainer>
  </div>
</template>

<script setup lang="ts">
import {
  SButtonListSkeleton,
  SHeadingSkeleton,
  STextSkeleton,
} from "@solvari/components";

import CompanyWallMunicipalityCardSkeleton from "~/features/company-wall/components/company-wall-municipality/CompanyWallMunicipalityCardSkeleton.vue";
import SectionContainer from "~/shared/components/SectionContainer.vue";
</script>
